// University of Montana's undergraduate majors (#2839). Read on 2026-10-01
// from the official 2026-2027 Academic Catalog's "List of All University of
// Montana Programs", tab "All Programs by College/School/Department"
// (catalog.umt.edu/programs/). Every bachelor's line under Undergraduate
// Programs is kept as the catalog names it, options included (B.A., B.S.,
// B.F.A., B.M., B.M.E., B.S. in Business Administration, Bachelor of Social
// Work, Bachelor of Applied Science), plus Multidisciplinary Studies, which
// the catalog lists without a suffix and whose page names it the Bachelor
// of Arts in Multidisciplinary Studies. Minors, certificates, Missoula
// College's associate degrees and certificates, Pre-Law, Pre-Medical
// Sciences and the Doctor of Pharmacy are left out. The degree suffix moves
// to the degree field; an option stays in the name ("Art - Art
// Education"). College names are the catalog's; its "Interdisciplinary
// Majors, Minors, and Certificates" heading is shortened to
// "Interdisciplinary programs" because only its two majors appear here.
const majors = {
    "slug": "university-of-montana",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in the University of Montana's official 2026-2027 Academic Catalog, grouped by the college that offers it, with the degree it leads to, options included as the catalog lists them. Minors, certificates, Missoula College associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of the Arts and Media",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art - Art Education",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art - Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Media Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Media Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Game Design & Interactive Media",
                    "degree": "B.F.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music - Instrumental Jazz Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M.E."
                },
                {
                    "name": "Composition - Contemporary Classical",
                    "degree": "B.M."
                },
                {
                    "name": "Composition - Pop and Commercial",
                    "degree": "B.M."
                },
                {
                    "name": "Performance - Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Performance - Keyboard",
                    "degree": "B.M."
                },
                {
                    "name": "Performance - Voice",
                    "degree": "B.M."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre - Theatre Education",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre - Acting for Film & Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre - Design & Technology",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre - Musical Theatre Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance - Pre-Dance Therapy",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Business Management",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Entertainment, Events, and Sports Management",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "International Business",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "B.S. in Business Administration"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Phyllis J. Washington College of Education",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education P-3",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "W.A Franke College of Forestry and Conservation",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Earth, Water, and Climate Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Parks, Tourism, and Recreation Management",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Biology - Aquatic",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Biology - Terrestrial",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Biology - Integrated Aquatic/Terrestrial",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Integrative Physiology - Health and Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                },
                {
                    "name": "Communicative Sciences and Disorders",
                    "degree": "B.A."
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Pharmaceutical Science - Non-Professional Concentration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Humanities and Social Sciences",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "African-American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology - Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology - Cultural and Ethnic Diversity",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology - Forensic and Biological Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology - Linguistic Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Central and Southwest Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies - Advocacy and Social Movements",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies - Interpersonal and Family Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies - Organizational and Strategic Communication",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics - Economics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.F.A."
                },
                {
                    "name": "English - Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "English - Literature",
                    "degree": "B.A."
                },
                {
                    "name": "English - Teaching English",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History - History Education",
                    "degree": "B.A."
                },
                {
                    "name": "History-Political Science (Social Studies Education)",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Native American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy - Environmental Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy - Philosophy and Law",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - American Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - International Relations and Comparative Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - Political Science Education",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - Public Administration and Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - Public Law & Political Theory",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology - Psychology Education",
                    "degree": "B.A."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Inequality and Social Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Sociology Education",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "French - French Language Education",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "German - German Language Education",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish - Spanish Language Education",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biology - Biological Education",
                    "degree": "B.A."
                },
                {
                    "name": "Biology - Teacher Preparation General Science Broadfield",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology - Ecology and Organismal Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology - Genetics and Evolution",
                    "degree": "B.S."
                },
                {
                    "name": "Human Biology and Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology, Immunology, & Infectious Disease",
                    "degree": "B.S."
                },
                {
                    "name": "Integrative Microbiology",
                    "degree": "B.A."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience - Cellular and Molecular Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience - Cognitive Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry - Health Professions",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Forensic Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science - Algorithm Design",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science - Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science - Software Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science-Mathematical Sciences (Combined Major)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical Sciences-Computer Science (Combined Major)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics - Applied Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics - Combinatorics and Optimization",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics - Mathematics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics - Pure Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics - Statistics and Data Science",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Computational Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Engineering Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Physics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Teaching Broadfield Science",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Interdisciplinary programs",
            "source": {
                "label": "University of Montana 2026-2027 Academic Catalog, List of All Programs",
                "url": "https://catalog.umt.edu/programs/"
            },
            "majors": [
                {
                    "name": "Health Services Administration",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Skilled Trades Management",
                    "degree": "Bachelor of Applied Science"
                }
            ]
        }
    ]
};

export default majors;
